export enum TipoUsuario {
    ADMINISTRADOR = 'Admin',
    MASTER = 'Master',
    GERENTE = 'Gerente',
    //AUDITAGEM = 'Auditagem',
    AUXILIAR_DE_ESTOQUE = 'Auxiliar de Estoque'
}